import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Details from '../details';
import useUserStore from '../../../stores/user';
import useOrganizationStore from '../../../stores/organization';
import useCommonStore from '../../../stores/common';
import styles from './styles.module.scss';

const OrganizationDetailsOnly = ({ match, history }) => {
  const { id } = match.params;
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const isAdmin = useUserStore((state) => state.isAdmin);
  const organizationId = useUserStore((state) => state.organizationId);
  const setSelectedOrganizationId = useOrganizationStore((state) => state.setSelectedOrganizationId);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const toggleExpandDetails = useCommonStore(
    (state) => state.toggleExpandDetails,
  );

  useEffect(() => {
    if (!id) return;

    // If not PC_ADMIN and not viewing their own organization, redirect to their org
    if (!isPCAdmin && id !== organizationId?.toString()) {
      history.replace(`/v2/organizations/${organizationId}`);
      return;
    }

    // Set the selected organization ID
    setSelectedOrganizationId(id);
    
    // Show details view
    setShowDetails(true);
    if (!expandDetails) {
      toggleExpandDetails();
    }

    // Cleanup function
    return () => {
      setSelectedOrganizationId(null);
      setShowDetails(false);
      if (expandDetails) {
        toggleExpandDetails();
      }
    };
  }, [id, isPCAdmin, organizationId, setSelectedOrganizationId, setShowDetails, expandDetails, toggleExpandDetails]);

  return (
    <div className={styles.detailsOnlyContainer}>
      <Details isDetailsOnly={true} />
    </div>
  );
};

export default withRouter(OrganizationDetailsOnly);